import type { ActionHandlerMap } from "./types";

import { instance } from "@/lib/axios/instance";

export const indeedActions: ActionHandlerMap = {
  sync: async ({ integrationName, clientId, onSuccess, onError }) => {
    try {
      await instance.post(
        `/api/v2/Integrations/${integrationName}/job-sync/Vacancies/Resync`,
        {},
        { params: { clientId } }
      );
      onSuccess?.();
    } catch (error) {
      onError?.(error instanceof Error ? error : new Error(String(error)));
    }
  },
  repair: async ({ integrationName, clientId, onSuccess, onError }) => {
    try {
      await instance.post(
        `/api/v2/Integrations/${integrationName}/job-sync/Vacancies/Repair`,
        {},
        { params: { clientId } }
      );
      onSuccess?.();
    } catch (error) {
      onError?.(error instanceof Error ? error : new Error(String(error)));
    }
  },
};
